import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import classNames from "classnames";
import AutoComplete1 from "../../Utils/Select";
import { VERDA_CONSTS } from "../../Utils/StaticData/Constant";
import ProspectView from "./ProspectView";
const AddProspectAssignAgent = ({
  value1,
  value2,
  options,
  onChange,
  handleDropdown,
  eventType,
  agentDisable,
  propspectList,
  propectName,
  prospectData,
  customerId,
}) => {
  return (
    <>
      <Grid item xs={12} spacing={2} direction="row" className="d-flex mb-2">
        <Grid item xs={12} className="d-flex">
          {eventType !== "Sales" && (
            <Grid item xs={customerId !== VERDA_CONSTS.ID ? 5 : 6}>
              <span className="label-container w-100 text-left">
                <label className="labelcampaign" for="campaignMedia">
                  Add Prospect
                </label>
                <br />
                <AutoComplete1
                  name="prospectName"
                  size="small"
                  variant="outlined"
                  handleChange={handleDropdown("prospectName")}
                  error={!propectName[0]?.label}
                  options={propspectList.map((data) => ({
                    label: data.label,
                    value: data.value,
                  }))}
                  value={
                    propectName?.length > 0
                      ? propectName[0]
                      : { label: "---Select---", value: "" }
                  }
                  // margin="20px auto"
                  width="100%"
                  fontSize="1rem"
                  show={true}
                  height="1rem"
                  dashboard="eventCalender"
                  fullWidth
                />
              </span>
            </Grid>
          )}
          {eventType !== "Sales" && customerId !== VERDA_CONSTS.ID && (
            <Grid item xs={1}>
              <br />
              <ProspectView prospectName={propectName} />
            </Grid>
          )}
          <Grid item xs={customerId !== VERDA_CONSTS.ID ? 5 : 6}>
            <span className="label-container w-100 text-left">
              <label className="labelcampaign" for="campaignMedia">
                Assign Agent
              </label>
              <br />
              <AutoComplete1
                name="agentName"
                size="small"
                variant="outlined"
                handleChange={handleDropdown("agentName")}
                error={
                  !value1 ||
                  value1.label === "---Select---" ||
                  value1.label === "Select"
                }
                options={options.map((data) => ({
                  label: data.label,
                  value: data.emailId,
                  agentId: data.value,
                  userRole: data?.userRole,
                }))}
                // defaultValue={options?.find(
                //   (data) => data?.label === value1?.label
                // )}
                value={value1 ? value1 : { label: "---Select---", value: "" }}
                // margin="20px auto"
                width="100%"
                fontSize="1rem"
                show={true}
                height="1rem"
                dashboard="eventCalender"
                fullWidth
                disabled={agentDisable}
              />
            </span>
          </Grid>
          {eventType === "Sales" && (
            <Grid item xs={6} direction="column">
              <Grid
                item
                xs={12}
                direction="column"
                className={`d-flex ${agentDisable && "disable-form"}`}
              >
                <label
                  className="labelcampaign invisible mb-1"
                  for="campaignMedia"
                >
                  Assign Agent
                </label>
                <TextField
                  name="maxAttendees"
                  value={value2}
                  size="small"
                  fullWidth
                  onChange={onChange}
                  label="Max.Attendees"
                  variant="outlined"
                  error={value2 === ""}
                  type="number"
                  inputProps={{
                    autoComplete: "off",
                    spellcheck: "false",
                    "aria-autocomplete": "both",
                    "aria-haspopup": "false",
                  }}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

const ContactMethod = ({ phone, email, onChange, formatPhoneNumber }) => {
  return (
    <Grid
      containter
      xs={12}
      lg={12}
      spacing={2}
      direction="row"
      className="d-flex"
    >
      <Grid item xs={2} className="d-flex">
        <label>Contact Method</label>
      </Grid>
      <Grid item xs={10} direction="column">
        <TextField
          name="phone"
          //value={formatPhoneNumber(phone)}
          value={phone}
          size="small"
          fullWidth
          onChange={onChange}
          label="Phone"
          variant="outlined"
          className="mb-2"
          // error={!phone}
          inputProps={{
            maxLength: 12,
            autoComplete: "off",
            spellcheck: "false",
            "aria-autocomplete": "both",
            "aria-haspopup": "false",
          }}
        />
        <TextField
          name="email"
          value={email}
          size="small"
          fullWidth
          onChange={onChange}
          label="Email"
          className="mb-2"
          variant="outlined"
          // error={!email}
          inputProps={{
            autoComplete: "off",
            spellcheck: "false",
            "aria-autocomplete": "both",
            "aria-haspopup": "false",
          }}
        />
      </Grid>
    </Grid>
  );
};

const RadioButtonsComponent = ({ label, value, setValue, classes }) => {
  return (
    <div className="d-flex">
      <FormControl
        component="fieldset"
        className={classes.radioButtonContainer}
        fullWidth
      >
        <FormLabel
          filled={false}
          style={{ width: "auto", display: "flex", marginRight: 10 }}
          component="h6"
        >
          {label}
        </FormLabel>
        <RadioGroup
          aria-label={label}
          name={label}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          row
        >
          <FormControlLabel
            value="Y"
            control={<Radio color="primary" />}
            label="Yes"
          />
          <FormControlLabel
            value="N"
            control={<Radio color="primary" />}
            label="No"
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

const NoteInputComponent = ({ value, handleChange, classes }) => {
  return (
    <Grid containter xs={12} lg={12} spacing={2} direction="row">
      <Grid item xs={12} direction="column">
        <TextField
          name="note"
          value={value}
          size="small"
          fullWidth
          onChange={(e) => handleChange(e)}
          label="Notes"
          variant="outlined"
          className={classNames(classes.eventNotes, "mb-2 mt-2")}
          rows={3}
          minRows={3}
          multiline
          style={{ height: "auto !important" }}
          inputProps={{
            maxLength: 200,
            autoComplete: "off",
            spellcheck: "false",
            "aria-autocomplete": "both",
            "aria-haspopup": "false",
          }}
        />
      </Grid>
    </Grid>
  );
};
export {
  AddProspectAssignAgent,
  ContactMethod,
  RadioButtonsComponent,
  NoteInputComponent,
};
